import { CollageIcon } from './CollageIcon';

/**
 * author: Google
 * id 8FD44CCD-5073-4C73-98BE-139F777F6E94
 * name collage
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/collage.svg
 * tags
 */
export const AutoAwesomeMosaicIcon = CollageIcon;
export default AutoAwesomeMosaicIcon